import { render, staticRenderFns } from "./TestReportGenerator.vue?vue&type=template&id=38acf764&scoped=true&"
import script from "./TestReportGenerator.vue?vue&type=script&lang=js&"
export * from "./TestReportGenerator.vue?vue&type=script&lang=js&"
import style0 from "./TestReportGenerator.vue?vue&type=style&index=0&id=38acf764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acf764",
  null
  
)

export default component.exports